var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilledicons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 15.0001V27.0001C28 27.2653 27.8946 27.5196 27.7071 27.7072C27.5196 27.8947 27.2652 28.0001 27 28.0001H20C19.7348 28.0001 19.4804 27.8947 19.2929 27.7072C19.1054 27.5196 19 27.2653 19 27.0001V20.5001C19 20.3674 18.9473 20.2403 18.8536 20.1465C18.7598 20.0527 18.6326 20.0001 18.5 20.0001H13.5C13.3674 20.0001 13.2402 20.0527 13.1464 20.1465C13.0527 20.2403 13 20.3674 13 20.5001V27.0001C13 27.2653 12.8946 27.5196 12.7071 27.7072C12.5196 27.8947 12.2652 28.0001 12 28.0001H5C4.73478 28.0001 4.48043 27.8947 4.29289 27.7072C4.10536 27.5196 4 27.2653 4 27.0001V15.0001C4.00025 14.4697 4.21112 13.9612 4.58625 13.5863L14.5863 3.5863C14.9613 3.21151 15.4698 3.00098 16 3.00098C16.5302 3.00098 17.0387 3.21151 17.4137 3.5863L27.4137 13.5863C27.7889 13.9612 27.9998 14.4697 28 15.0001Z",
    fill: "#00308F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledicons);
export default __webpack_public_path__ + "static/media/Filled icons.0ebb9d6fb6ffc2349f98e23227ab6702.svg";
export { ForwardRef as ReactComponent };